export const OTP_MAX_DIGIT = 6;
